module.exports = __webpack_public_path__ + "img/img_home_banner1.b8d5fb4e.png";